/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { FormattedDate } from 'react-intl';
import Shiitake from 'shiitake';

import MoreInfo from '../partials/MoreInfo';

import styles from '../../../styles/cards/latest-news.scss';

const propTypes = {
    title: PropTypes.string,
    summary: PropTypes.string,
    url: PropTypes.string,
    date: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    summary: null,
    url: null,
    date: null,
    className: null,
};

const LatestNewsCard = ({
    title, summary, url, date, className,
}) => (
    <div
        className={classNames({
            [styles.container]: true,
            [className]: className !== null,
        })}
    >
        <div className={styles.inner}>
            {date !== null ? (
                <div className={styles.date}>
                    <FormattedDate
                        value={moment(date, 'YYYY-MM-DD HH:mm:ss').toDate()}
                        year="numeric"
                        month="long"
                        day="numeric"
                    />
                </div>
            ) : null}

            {title !== null ? (
                <h4 className={styles.title}>
                    <Link to={url}>
                        <Shiitake lines={3} throttleRate={200} tagName="div">
                            {title}
                        </Shiitake>
                    </Link>
                </h4>
            ) : null}

            <hr />

            {summary !== null && typeof summary === 'string' ? (
                <div className={styles.summary}>
                    {`${summary.substr(0, 150)}${summary.length > 150 ? '...' : ''}`}
                </div>
            ) : null}

            {url !== null ? (
                <div className={styles.link}>
                    <MoreInfo
                        label={{
                            id: 'content.more',
                            defaultMessage: 'More',
                        }}
                        link={url}
                    />
                </div>
            ) : null}
        </div>
    </div>
);

LatestNewsCard.propTypes = propTypes;
LatestNewsCard.defaultProps = defaultProps;

export default LatestNewsCard;



// WEBPACK FOOTER //
// ./js/components/cards/LatestNews.jsx